<script lang="ts" setup>
import { PermissionKeys } from '@/classes/user_classes/essentialsPermissionsControl'
import { GettersTypes, type State } from '@/store/store_types'
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore<State>()
const user = computed(() => store.getters[GettersTypes.getCurrentUser])
const isAdmin = computed(() => store.state.permissions?.get(PermissionKeys.isPolicyHolder) ?? false)
const fleetData = computed(() => store.state.fleet)
const fleet_name = computed(() => fleetData.value?.name ?? 'Fleet Name')
const logo_url = computed(() => fleetData.value?.logoSrc ?? '')
</script>
<template>
  <v-card class="pa-5 bg-pwt_snow d-flex align-center" flat>
    <v-img :src="logo_url" max-width="150" class="mb-4" />
    <v-card flat class="flex-1" color="transparent">
      <v-card-title>{{ fleet_name }}</v-card-title>
      <v-card-text>
        <p>{{ isAdmin ? 'Admin' : 'Member' }}</p>
        <p>{{ user.displayName }}</p>
      </v-card-text>
    </v-card>
  </v-card>
</template>
